import React from 'react'
import { IconButton as IconBtn } from '@material-ui/core'
import Icon from '@mdi/react'

export const IconButton = ({ icon, onClick, size }) => (
    <IconBtn onClick={onClick}>
        <Icon path={icon} size={size} />
    </IconBtn>
)
